'use client';

import { Accordion } from '$components/Accordion';
import { FragmentType, graphql, useFragment } from '$contentful-gql/index';

const faqFragment = graphql(/* GraphQL */ `
  fragment faq on Faq {
    ...sys
    name(locale: $language)
    questionsCollection(skip: 0, limit: 10, preview: $preview) {
      total
      items {
        ...text
      }
    }
  }
`);

export function FaqProvider(props: { item: FragmentType<typeof faqFragment> }) {
  const carousel = useFragment(faqFragment, props.item);

  const faqProps = {
    content: carousel.questionsCollection.items,
    title: 'FAQs',
  };

  return <Accordion index={0} active={false} {...faqProps} />;
}
